import { createFileRoute } from '@tanstack/react-router';
import PersonalDataPage from '@/features/resume-builder/personal-data';

export const Route = createFileRoute('/modulos/$moduleId_/curriculo/dados-pessoais')({
  component: PersonalDataPage,
});
